<template>
    <div>

        <b-collapse :open="false" aria-id="contentIdForA11y1"   @open="collapseOpen" @close="collapseClose">
            <template #trigger>
                <b-button type="is-info is-light">More Info...</b-button>
            </template>
            <div class="notification">
                <div class="content">
                    <b-table
                            :data="isEmpty ? [] : orderLabRequestDetailFromIDOrder"
                            bordered
                            striped
                            hoverable
                            :loading="isTblloading"
                            focusable
                            mobile-cards>


                        <b-table-column   label="ID" v-slot="props">
                            {{ props.row.idpart }}
                        </b-table-column>

                        <b-table-column  label="Descitpion" v-slot="props">
                            {{ props.row.partdecp }}
                        </b-table-column>

                        <b-table-column   label="Amount" v-slot="props">
                            {{ props.row.amount }}
                        </b-table-column>

                        <b-table-column   label="Unit" v-slot="props">
                            {{ props.row.unit_part }}
                        </b-table-column>

                        <b-table-column   label="status" v-slot="props">
                            <b-icon pack="fas"
                                    :icon="props.row.status   ? 'check' : 'ban'"
                                    :type="props.row.status   ? 'is-success' : 'is-danger'">
                            </b-icon>
                        </b-table-column>



                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>






                    <FooterRequest v-if="dataRequestInfo.length>0" :dataReqToFooter="dataRequestInfo"/>




                </div>
            </div>
        </b-collapse>
    </div>

</template>

<script>
    import axios from "axios";
    import {   getBaseURLforBackEnd , getConfigAxios ,  }  from '@/utils.js'
    import FooterRequest from "../LABNonAutomate/FooterRequest";
    import { mapState } from "vuex";

    export default {
        name: "DetailUsedPartFromRequestDataEachLab",
        components:{
            FooterRequest
        },
        props:{
            IDLABSelected : Object
        },
        computed:{
             ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            collapseOpen(){
                // console.log('collapseOpen')
                // orderlabrequestdetailfromidlab

                const vm = this
                //
                const datTo = {
                    "idlab" : this.IDLABSelected.idlab
                }
                this.isTblloading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`  
                axios.post(`${getBaseURLforBackEnd()}/api/orderlabrequestdetailfromidlab`,datTo,getConfigAxios())
                    .then((res) => {
                        vm.isTblloading = false
                        vm.orderLabRequestDetailFromIDOrder = res.data

                    })
                    .catch(err => {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                    })
                    .finally(() => {
                        vm.isTblloading = false
                    })


                //


                this.isTblloading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/request_info_from_idlab`,datTo,getConfigAxios())
                    .then((res) => {
                        vm.isTblloading = false
                        vm.dataRequestInfo = res.data

                    })
                    .catch(err => {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                    })
                    .finally(() => {
                        vm.isTblloading = false
                    })







            },
            collapseClose(){
                // console.log('collapseClose')
                this.orderLabRequestDetailFromIDOrder = []
                this.dataRequestInfo = []
            }
        },
        data(){
            return{
                isEmpty : false,
                isTblloading: false,

                //
                //  mockup data
                //
                // orderLabRequestDetailFromIDOrder :[    {
                //     "idpart": "040000000551",
                //     "partdecp": "ค่าบริการเก็บตัวอย่าง cytology (80)",
                //     "amount": 1.0,
                //     "unit_part": "ครั้ง",
                //     "status": "Y"
                // },
                //     {
                //         "idpart": "030080100101",
                //         "partdecp": "(ชันสูตร) ค่าตรวจวินิจฉัยเซลล์วิทยา (Cytology) สไลด์ (300)",
                //         "amount": 1.0,
                //         "unit_part": "ตำแหน่ง",
                //         "status": "Y"
                //     }]
                orderLabRequestDetailFromIDOrder : [],
                dataRequestInfo : []
            }
        }
    }
</script>

<style scoped>

</style>